import { PatientHelper } from "@/Common/Helpers/PatientHelper";
import { SidebarHelper } from "@/Common/Helpers/SidebarHelper";
import { MyleTabKey } from "@/Common/Models/MyleMenu/enums/MyleTabKey";
import { ISidebarModel } from "@/Common/Models/UI/Sidebar/ISidebarModel";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { ServerEvent } from "@/Common/Stores/Actions/ServerEvent";
import { BaseStore } from "@/Common/Stores/BaseStore";
import { SidebarHandler } from "@/Common/Stores/Handlers/Local/Sidebar/SidebarHandler";
import { RequestMapper, ServerResponseMapper } from "@/Common/Stores/Handlers/Server/RequestMapper";
import { SidebarResponseHandler } from "@/Common/Stores/Handlers/Server/Sidebar/SidebarResponseHandler";
import { SidebarActions } from "./Actions/SidebarActions";

let defaultInstance: SidebarStore;

class SidebarStore extends BaseStore {
    private Mapper: RequestMapper;
    private ServerMapper: ServerResponseMapper;
    private handler: SidebarHandler;
    private responseHandler: SidebarResponseHandler;

    public currentSearchId = 1;
    public Model: ISidebarModel;
    public Actions: SidebarActions;

    constructor() {
        super();
        var self = this;
        this.handler = new SidebarHandler();
        this.Mapper = new RequestMapper();
        this.Mapper.AddInstance(this.handler);
        this.ServerMapper = new ServerResponseMapper();
        this.Actions = new SidebarActions();
        this.responseHandler = new SidebarResponseHandler(this.Actions);
        this.ServerMapper.AddInstance(this.responseHandler);

        var defaultSidebarModel = SidebarHelper.GetSidebarModel();
        var defaultCreationModel = PatientHelper.getDefaultPatientCreationModel();
        defaultSidebarModel.PatientCreationModel = defaultCreationModel;

        this.Model = Immutable.fromJS(defaultSidebarModel);

        this.ClientDispatchToken = LocalEventDispatcher.register((request: LocalEvent) => self.Mapper.Map(request, self));

        this.ServerDispatchToken = ServerResponseDispatcher.register((response: ServerEvent) => { self.ServerMapper.Map(response, self); });
    }

    public static createSingleton(): SidebarStore {
        return this.createStoreSingleton(defaultInstance, () => defaultInstance = new SidebarStore());
    }

    public static createSingletonFrom(store: SidebarStore, copy: boolean = true): SidebarStore {
        return copy
            ? Object.assign(this.createSingleton(), store)
            : this.createStoreSingleton(defaultInstance, () => defaultInstance = store);
    }

    public openSidebar = (): void => this.setDataAndApplyIsOpenOrClosed(true);

    public closeSidebar = (): void => this.setDataAndApplyIsOpenOrClosed(false);

    public autoOpenClose(): void {
        let openSesame;
        switch (sessionStore.activeMYLEMenuTab) {
            case MyleTabKey.Calendar:
                openSesame = this.Model.get("CalendarSidebarIsOpenOnTabChange");
                break;
            default:
                openSesame = this.Model.get("GlobalSidebarIsOpenOnTabChange");
        }

        this.Model = this.Model.set("IsOpen", openSesame);
    }

    public toggleOpenClose(): void {
        let openSesame;

        switch (sessionStore.activeMYLEMenuTab) {
            case MyleTabKey.Calendar:
                openSesame = this.Model.get("CalendarSidebarIsOpenOnTabChange");
                break;
            default:
                openSesame = this.Model.get("GlobalSidebarIsOpenOnTabChange");
        }

        !openSesame ? this.openSidebar() : this.closeSidebar();
    }

    private setDataAndApplyIsOpenOrClosed(state: boolean): void {
        switch (sessionStore.activeMYLEMenuTab) {
            case MyleTabKey.Calendar:
                this.Model = this.Model.set("CalendarSidebarIsOpenOnTabChange", state);
                break;
            default:
                this.Model = this.Model.set("GlobalSidebarIsOpenOnTabChange", state);
        }

        this.Model = this.Model.set("IsOpen", state);
        this.refreshWindowResize();
    }

    private refreshWindowResize(): void {
        window.setTimeout(() => $(window).trigger("resize"), 150);
    }
}

export { SidebarStore, defaultInstance as sidebarStore };
